import React from 'react';
import SettingsSaveButton from './SettingsSaveButton';
import { useLanguage } from '../../../i18n/LanguageContext';

const MotorBrandSettingsCard = React.memo(({
  title,
  subtitle,
  productType,
  extras,
  setExtras,
  handleSaveSettings,
  isSavingSettings
}) => {
  const { t } = useLanguage();
  const updateField = (field, val) => {
    setExtras(prev => ({
      ...prev,
      [field]: val
    }));
  };

  const brands = [
    { num: 1, nameKey: 'motorFirma1Name', priceKey: 'motorFirma1Price', kumandaKey: 'motorFirma1KumandaPrice', defaultName: t('productList.motorSettings.firm', 'Firma 1', { num: 1 }) },
    { num: 2, nameKey: 'motorFirma2Name', priceKey: 'motorFirma2Price', kumandaKey: 'motorFirma2KumandaPrice', defaultName: t('productList.motorSettings.firm', 'Firma 2', { num: 2 }) },
    { num: 3, nameKey: 'motorFirma3Name', priceKey: 'motorFirma3Price', kumandaKey: 'motorFirma3KumandaPrice', defaultName: t('productList.motorSettings.firm', 'Firma 3', { num: 3 }) }
  ];

  const defaultTitle = t('productList.motorSettings.title', 'Motor ve Kumanda Ayarları');
  const defaultSubtitle = t('productList.motorSettings.subtitle', '3 ayrı motor firması için motor ve kumanda ücretleri');

  return (
    <div className="settings-card motor-brands-settings-card">
      <div className="settings-card-header">
        <div className="settings-card-title">
          <i className="fas fa-cogs"></i>
          <div className="settings-card-title-text">
            <h4>{title || defaultTitle}</h4>
            <span className="settings-card-subtitle">
              {subtitle || defaultSubtitle}
            </span>
          </div>
        </div>
        <SettingsSaveButton
          onClick={() => handleSaveSettings()}
          isSaving={isSavingSettings}
        />
      </div>

      <div className="motor-brands-container">
        <div className="motor-brands-grid">
          {brands.map(b => (
            <div key={b.num} className="motor-brand-item">
              <div className="motor-brand-header">
                <span className="motor-brand-badge">
                  {b.num}
                </span>
                <input
                  type="text"
                  className="motor-brand-name-input"
                  placeholder={b.defaultName}
                  value={extras?.[b.nameKey] ?? ''}
                  onChange={(e) => updateField(b.nameKey, e.target.value)}
                />
              </div>

              <div className="motor-brand-prices-row">
                <div className="motor-price-field">
                  <label title={t('productList.motorSettings.motorPrice', 'Motor (€)')}>
                    {t('productList.motorSettings.motorPrice', 'Motor (€)')}
                  </label>
                  <input
                    type="number"
                    step="0.01"
                    placeholder="0.00"
                    value={extras?.[b.priceKey] ?? ''}
                    onChange={(e) => updateField(b.priceKey, e.target.value)}
                  />
                </div>

                <div className="motor-price-field">
                  <label title={t('productList.motorSettings.kumandaPrice', 'Kumanda (€)')}>
                    {t('productList.motorSettings.kumandaPrice', 'Kumanda (€)')}
                  </label>
                  <input
                    type="number"
                    step="0.01"
                    placeholder="0.00"
                    value={extras?.[b.kumandaKey] ?? ''}
                    onChange={(e) => updateField(b.kumandaKey, e.target.value)}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
});

export default MotorBrandSettingsCard;
